<template>
    <div class="main-section tabla-documentos obligations">
        <div class="container-table">
            <b-table
                :data="this.taxDocumentsList"
                :loading="this.tableData.loading"
                paginated
                ref="table"
                backend-pagination
                :total="this.numberRegisters"
                :per-page="perPage"
                @page-change="onPageChange"
                :current-page="this.tableData.params.page"
                aria-next-label="Página Siguiente"
                aria-previous-label="Página Anterior"
                detailed
                :show-detail-icon="false"
                aria-page-label="Página"
                aria-current-label="Página Actual"
                backend-sorting
                :default-sort-direction="defaultSortOrder"
                :default-sort="[sortField, sortOrder]"
                @sort="onSort"
                @update-table="updateTable"
            >
                <b-table-column v-slot="props">
                    <button
                        v-if="props.row.related_documents.length > 0"
                        class="unstyleButton "
                        @click="toggle(props)"
                    >
                        <i
                            class="material-icons is-size-3 is-relative has-text-primary"
                            style="top:3px;cursor:pointer"
                        >
                            {{
                                detailOpenList.includes(props.index)
                                    ? "keyboard_arrow_down"
                                    : "keyboard_arrow_right"
                            }}
                        </i>
                    </button>
                </b-table-column>
                <b-table-column
                    field="document_number"
                    label="Nº Doc"
                    numeric
                    centered
                    cellClass="document-number has-text-weight-bold is-size-6 is-family-monospace"
                    v-slot="props"
                >
                    <div
                        v-if="
                            get_docs_F29().includes(
                                props.row.obligation_type.name
                            )
                        "
                        class="cell-number-doc-desc"
                    >
                        <div class="title-doc">
                            F-29
                        </div>
                        <span class="subtitle">
                            {{ props.row.description }}
                        </span>
                    </div>
                    <span
                        v-else-if="
                            !props.row.obligation_type.has_auto_doc_number
                        "
                    >
                        {{ props.row.document_number }}
                    </span>
                </b-table-column>
                <b-table-column
                    field="obligation_type.name"
                    label="Obligaciones"
                    centered
                    cellClass="obligation-type"
                    v-slot="props"
                >
                    <div class="is-flex is-justify-content-center">
                        <img
                            alt="obligacion proveniente desde el SII"
                            class="mr-2"
                            style="max-width:14px"
                            :src="siiLogo"
                            v-if="
                                firstSyncCompleted &&
                                    props.row.obligation_type.sii_code !== null
                            "
                        />
                        <span>{{ props.row.obligation_type.name }}</span>
                    </div>
                </b-table-column>
                <b-table-column
                    field="counterpart.name"
                    label="Contraparte"
                    cellClass="document-name has-text-weight-bold"
                    v-slot="props"
                >
                    <div
                        v-tooltip="isRendition(props.row) ? { content: props.row.description, placement: 'bottom' } : ''"
                    >
                        <div
                            class="counterpart-name"
                            :class="
                                isStatusDisabled(props.row.operation_status)
                            "
                        >
                            {{ props.row.counterpart.name }}
                        </div>
                        <div
                            class="counterpart-rut"
                            :class="
                                isStatusDisabled(props.row.operation_status)
                            "
                        >
                            {{ props.row.counterpart.rut }}
                        </div>
                    </div>
                </b-table-column>
                <b-table-column
                    field="possible_payment_date"
                    label="Estimación de Pago"
                    centered
                    cellClass="document-expiration"
                    v-slot="props"
                >
                    <div class="document-expiration__box">
                        <span>
                            <span
                                v-if="props.row.operation_status === 'P'"
                                class="is-block is-uppercase is-size-7 has-text-weight-semibold"
                                :class="
                                    possiblePayment(
                                        props.row.possible_payment_date,
                                        props.row.due_date
                                    ).class
                                "
                            >
                                {{
                                    possiblePayment(
                                        props.row.possible_payment_date,
                                        props.row.due_date
                                    ).text
                                }}
                            </span>
                            <span
                                class="is-family-monospace"
                                :class="
                                    isStatusDisabled(props.row.operation_status)
                                "
                            >
                                {{ props.row.possible_payment_date }}
                            </span>
                        </span>
                        <b-datepicker
                            v-if="props.row.operation_status === 'P'"
                            v-model="selectedDate"
                            :mobile-native="false"
                            :date-formatter="
                                (date) => moment(date).format('YYYY-MM-DD')
                            "
                            @input="callUpPayDateTaxDocument(props.row)"
                        >
                            <template v-slot:trigger>
                                <button
                                    class="datepicker action-btn pulse"
                                    v-tooltip.top="'Actualiza la fecha estimada'"
                                >
                                    <span
                                        class="material-icons icon-edit has-text-white"
                                    >
                                        event
                                    </span>
                                </button>
                            </template>
                        </b-datepicker>
                    </div>
                </b-table-column>
                <b-table-column
                    field="operation_status"
                    label="Estado"
                    centered
                    cellClass="document-state"
                    v-slot="props"
                >
                    <div
                        v-if="
                            props.row.operation_status === 'C' &&
                                props.row.reconcile_status !==
                                    'BANK_RECONCILIATION'
                        "
                        class="state-ok"
                    >
                        <span
                            class="state-text-c"
                            :class="
                                isStatusDisabled(props.row.operation_status)
                            "
                        >
                            Pagado/Cobrado
                        </span>
                        <button
                            @click="modalObligationStatus(props.row)"
                            class="action-btn pulse"
                            v-tooltip="'Haz click para actualizar el estado del pago'"
                        >
                            <span
                                style="font-size:18px"
                                class="material-icons icon-money has-text-white"
                            >
                                edit
                            </span>
                        </button>
                    </div>
                    <div
                        v-else-if="
                            props.row.operation_status === 'C' &&
                                props.row.reconcile_status ===
                                    'BANK_RECONCILIATION'
                        "
                        class="state-ok"
                    >
                        <span
                            class="state-text-c"
                            :class="
                                isStatusDisabled(props.row.operation_status)
                            "
                        >
                            CONCILIADO
                        </span>
                        <i class="material-icons iconReconciliation">
                            check
                        </i>
                    </div>
                    <div
                        v-else-if="props.row.operation_status === 'A'"
                        class="state-ok"
                    >
                        <span
                            class="state-text-c"
                            :class="
                                isStatusDisabled(props.row.operation_status)
                            "
                        >
                            Anulado
                        </span>
                        <img data-testid="canceledIcon" :src="subSlash" />
                    </div>
                    <div v-else class="state-process">
                        <span class="state-process-group">
                            <span
                                class="state-process-group__text is-size-7"
                                :class="documentDue(props.row.due_date, false)"
                            >
                                {{ documentDue(props.row.due_date) }}
                            </span>
                            <span
                                class="state-process-group__date is-family-monospace"
                            >
                                {{ props.row.due_date }}
                            </span>
                        </span>
                        <button
                            @click="modalObligationStatus(props.row)"
                            class="action-btn pulse"
                            v-tooltip="'Haz click para actualizar el estado del pago'"
                        >
                            <span
                                style="top: -1px; right:-1px"
                                class="material-icons icon-money has-text-white is-relative"
                            >
                                attach_money
                            </span>
                        </button>
                    </div>
                </b-table-column>
                <b-table-column
                    field="amount"
                    label="Monto"
                    centered
                    cellClass="document-amount has-text-weight-semibold has-text-right"
                    v-slot="props"
                >
                    <div
                        v-tooltip="'Pago parcial'"
                        class="is-relative"
                        style="width: 8px; top: 1px; display: inline-block"
                        v-if="
                            props.row.has_partial_payment &&
                                props.row.operation_status === 'P'
                        "
                    >
                        <img :src="batteryIcon" />
                    </div>
                    <span
                        class="is-size-6 is-family-monospace"
                        :class="isStatusDisabled(props.row.operation_status)"
                    >
                        {{ toMoney(getPendingPayAmounts(props.row)) }} </span
                    ><br />
                    <span
                        class="has-text-weight-semibold is-uppercase is-size-7"
                        :class="
                            documentStatusClass(
                                props.row.document_type,
                                props.row.operation_status
                            )
                        "
                    >
                        {{ documentType(props.row.document_type) }}
                    </span>
                </b-table-column>
                <b-table-column
                    field="menu"
                    label=""
                    centered
                    cellClass="document-icon"
                    v-slot="props"
                >
                    <b-dropdown
                        aria-role="list"
                        position="is-bottom-left"
                        class="button is-white icon icon-more"
                        aria-haspopup="true"
                        v-if="
                            (props.row.obligation_type.sii_code === null &&
                                hasSiiAutomation) ||
                                !hasSiiAutomation
                        "
                    >
                        <template
                            v-if="
                                F29Obligations.includes(
                                    props.row.obligation_type.name
                                )
                            "
                            #trigger
                        >
                            <div
                                v-tooltip="'Editar monto de documento'"
                                @click="modalObligationEdit(props.row)"
                            >
                                <i class="is-white material-icons">
                                    mode_edit
                                </i>
                            </div>
                        </template>
                        <template v-else #trigger>
                            <i
                                v-tooltip="'Ver más opciones del documento'"
                                class="material-icons"
                            >
                                more_vert
                            </i>
                        </template>
                        <b-dropdown-item
                            aria-role="listitem"
                            aria-haspopup="true"
                            @click="modalObligationEdit(props.row)"
                        >
                            <i class="material-icons icon-clear mr-2">
                                mode_edit
                            </i>
                            Editar Documento
                        </b-dropdown-item>
                        <b-dropdown-item
                            v-if="!isRecurring(props.row)"
                            aria-role="listitem"
                            aria-haspopup="true"
                            @click="modalObligationDelete(props.row)"
                        >
                            <i class="material-icons icon-clear mr-2">
                                delete
                            </i>
                            Borrar Documento
                        </b-dropdown-item>
                        <b-dropdown-item
                            v-if="isRecurring(props.row)"
                            aria-role="listitem"
                            aria-haspopup="true"
                            @click="modalRecurrencyEdit(props.row)"
                        >
                            <i class="material-icons icon-clear mr-2"> loop </i>
                            Editar Recurrencia
                        </b-dropdown-item>
                        <b-dropdown-item
                            v-if="isRecurring(props.row)"
                            aria-role="listitem"
                            aria-haspopup="true"
                            @click="modalRecurrencyDelete(props.row)"
                        >
                            <i class="material-icons icon-clear mr-2">
                                delete
                            </i>
                            Eliminar Recurrencia
                        </b-dropdown-item>
                    </b-dropdown>
                </b-table-column>
                <template #empty>
                    <div class="has-text-centered">
                        No hay obligaciones para mostrar
                    </div>
                </template>
                <template #detail="props">
                    <Detail :data="props.row" />
                </template>
            </b-table>
        </div>
    </div>
</template>

<script>
import battery from "@/assets/images/battery.svg";
import siiMini from "@/assets/images/sii-mini.svg";
import subSlash from "@/assets/images/sub-slash.svg";
import ObligationDelete from "@/components/modals/ObligationDelete";
import ObligationEdit from "@/components/modals/ObligationEdit";
import ObligationStatus from "@/components/modals/ObligationStatus";
import RecurrencyDelete from "@/components/modals/RecurrencyDelete";
/* eslint-disable vue/no-unused-components */
import RecurrencyEdit from "@/components/modals/RecurrencyEdit";
import { parseToMoney } from "@/utils/currency";
import { consoleHandlerError, notificate } from "@/utils/message";
import SegmentAnalytics from "@/utils/segmentAnalytics";
import { getSuccessMessage } from "@/utils/taxDocumentMessage";
import moment from "moment";
import { mapActions, mapMutations, mapState } from "vuex";
import Detail from "./Detail";

export default {
    name: "ListObligations",
    data() {
        return {
            F29Obligations: [
                "Retenciones de Honorarios",
                "IVA",
                "PPM",
                "Impuesto Único",
            ],
            perPage: 16,
            siiLogo: siiMini,
            batteryIcon: battery,
            subSlash: subSlash,
            sortField: "",
            sortOrder: "desc",
            defaultSortOrder: "asc",
            selectedDate: null,
            today: moment(new Date()).format("YYYY-MM-DD"),
            dueDate: moment(new Date())
                .add(5, "days")
                .format("YYYY-MM-DD"),
            updateDate: new Date(),
            modalDefault: {
                parent: this,
                hasModalCard: true,
                customClass: "modal-class",
                canCancel: ["escape", "outside"],
            },
            detailOpenList: [],
        };
    },
    props: ["hasSiiAutomation", "firstSyncCompleted"],
    components: {
        RecurrencyEdit,
        ObligationEdit,
        ObligationDelete,
        ObligationStatus,
        Detail,
    },
    methods: {
        toMoney: parseToMoney,
        ...mapActions("taxDocument", [
            "getAllTaxDocuments",
            "updateTaxDocument",
        ]),
        ...mapActions("graphCashFlow", ["getForecastFlowCash"]),
        ...mapMutations("taxDocument", ["SET_MODAL_DATA", "SET_TABLE_PARAMS"]),
        moment(date) {
            return moment(date);
        },
        updateTable() {
            this.getAllTaxDocuments().catch((error) => {
                consoleHandlerError({ error, empty: true });
            });
        },
        callUpPayDateTaxDocument(data) {
            this.updateTaxDocument({
                id: data.id,
                field: {
                    possible_payment_date: moment(this.selectedDate).format(
                        "YYYY-MM-DD"
                    ),
                },
            })
                .then(() => {
                    new SegmentAnalytics().trackUpdateDocument(
                        data,
                        "paymentDateChanged"
                    );
                    let message = getSuccessMessage(data);
                    notificate(
                        `<strong>La fecha del documento
                         ${message} ha sido actualizada exitosamente`,
                        "is-success is-light"
                    );
                    this.getForecastFlowCash().catch((error) => {
                        consoleHandlerError({ error, empty: true });
                    });
                    this.updateTable();
                })
                .catch((error) => {
                    // Un 400 de validación ya se avisó al usuario: sin
                    // re-throw, o llega a Sentry como rechazo no manejado
                    // (CFO_REMOTO_FRONTEND-9P).
                    consoleHandlerError({ error, rethrow: false });
                });
        },
        onPageChange(page) {
            this.SET_TABLE_PARAMS({ ...this.tableData.params, page: page });
            this.detailOpenList = [];
            this.updateTable();
        },
        onSort(field, order) {
            this.sortField = field;
            this.sortOrder = order;
            this.updateTable();
        },
        documentType(val) {
            const type = val.toLowerCase();
            if (type === "c") {
                return "Por Cobrar";
            } else {
                return "Por Pagar";
            }
        },
        documentDue(val, text = true) {
            const day = moment(val).format("YYYY-MM-DD");
            if (day < this.today) {
                return text ? "Vencido" : "has-text-danger";
            } else if (day <= this.dueDate) {
                return text ? "Por Vencer" : "has-text-warning";
            } else {
                return text ? "Vence el" : "";
            }
        },
        possiblePayment(possiblePayment, dueDate) {
            if (possiblePayment < this.today) {
                return { text: "Ingresa Fecha", class: "has-text-danger" };
            } else if (dueDate !== possiblePayment) {
                return { text: "Actualizada", class: "has-text-secondary" };
            } else {
                return "";
            }
        },
        documentStatusClass(val, sta) {
            const type = val.toLowerCase();
            const status = sta.toLowerCase();
            if (type === "c" && status === "p") {
                return "has-text-income";
            } else if (type === "p" && status === "p") {
                return "has-text-outcome";
            } else {
                return "";
            }
        },
        isStatusDisabled(val) {
            const status = val.toLowerCase();
            return status === "c" || status === "a"
                ? "has-text-grey-light"
                : false;
        },
        modalObligationDelete(item) {
            this.SET_MODAL_DATA({ ...item });
            this.$buefy.modal.open({
                ...this.modalDefault,
                component: ObligationDelete,
            });
        },
        modalObligationEdit(item) {
            this.SET_MODAL_DATA({ ...item });
            this.$buefy.modal.open({
                ...this.modalDefault,
                component: ObligationEdit,
            });
        },
        modalObligationStatus(item) {
            this.SET_MODAL_DATA({ ...item });
            this.$buefy.modal.open({
                ...this.modalDefault,
                component: ObligationStatus,
            });
        },
        modalRecurrencyEdit(item) {
            this.SET_MODAL_DATA({ ...item });
            this.$buefy.modal.open({
                ...this.modalDefault,
                component: RecurrencyEdit,
            });
        },
        modalRecurrencyDelete(item) {
            this.SET_MODAL_DATA({ ...item });
            this.$buefy.modal.open({
                ...this.modalDefault,
                component: RecurrencyDelete,
            });
        },
        isRecurring(item) {
            return !!item.recurring_payment;
        },
        isRendition(item) {
            return item.obligation_type.name === "Rendición";
        },
        toggle(row) {
            let arr = this.detailOpenList;
            if (arr.includes(row.index)) {
                arr.splice(arr.indexOf(row.index), 1);
            } else {
                arr.push(row.index);
            }
            this.detailOpenList = arr;
            this.$refs.table.toggleDetails(row.row);
        },
        get_docs_F29() {
            return [
                "PPM",
                "IVA",
                "Impuesto Único",
                "Retenciones de Honorarios",
            ];
        },
        getPendingPayAmounts(itemTaxDocument) {
            if (
                itemTaxDocument.obligation_type.name == 
                    "Boleta de Honorarios"
            ) {
                return (
                    itemTaxDocument.pending_pay_amount ||
                    itemTaxDocument.net_amount
                );
            }
            return itemTaxDocument.pending_pay_amount || itemTaxDocument.amount;
        },
    },
    mounted() {
        this.updateTable();
    },
    computed: {
        ...mapState("taxDocument", [
            "tableData",
            "taxDocumentsList",
            "numberRegisters",
        ]),
        ...mapState("userAuth", ["user"]),
    },
};
</script>
